export default __webpack_public_path__ + "static/media/FrontCover.c7501bd3.txt";